import { ChartGroupByMode } from './params';

export enum ChartRendererType {
    BAR = 'bar',
    LINE = 'line',
    PIE = 'pie',
    LIST = 'list',
    METRIC = 'metric',
    HEATMAP = 'heatmap'
}

export enum ChartKey {
    TRANSACTION_VOLUME_BAR = 'transaction-volume-bar',
    TRANSACTION_VOLUME_LINE = 'transaction-volume-line',
    PUDO_TRANSACTION_VOLUME_BAR = 'pudo-transaction-volume-bar',
    PUDO_TRANSACTION_VOLUME_LINE = 'pudo-transaction-volume-line',
    PUDO_TRANSACTION_VOLUME_BY_STATE_LIST = 'pudo-transaction-volume-by-state-list',
    PUDO_TRANSACTION_TIMER_DROP_OFF_PENDING_WAITING_DAYS_DONUT = 'pudo-transaction-timer-drop-off-pending-waiting-days-donut',
    PUDO_TRANSACTION_TIMER_PICK_UP_PENDING_WAITING_DAYS_DONUT = 'pudo-transaction-timer-pick-up-pending-waiting-days-donut',
    PUDO_TRANSACTION_TIMER_DROP_OFF_PENDING_WAITING_DAYS_STACKED_BAR = 'pudo-transaction-timer-drop-off-pending-waiting-days-stacked-bar',
    PUDO_TRANSACTION_TIMER_PICK_UP_PENDING_WAITING_DAYS_STACKED_BAR = 'pudo-transaction-timer-pick-up-pending-waiting-days-stacked-bar',
    PUDO_TRANSACTION_TIMER_ACTIVITY_WEEKDAY_HEATMAP = 'pudo-transaction-timer-activity-weekday-heatmap',
    PUDO_TRANSACTION_TIMER_ACTIVITY_HOUR_DAY_HEATMAP = 'pudo-transaction-timer-activity-hour-day-heatmap',
    PUDO_TRANSACTION_VOLUME_BY_SLOT_DIMENSION_DONUT = 'pudo-transaction-volume-by-slot-dimension-donut',
    PUDO_TRANSACTION_VOLUME_BY_SPOT_DONUT = 'pudo-transaction-volume-by-spot-donut',
    PUDO_TRANSACTION_VOLUME_BY_SENDER_LIST = 'pudo-transaction-volume-by-sender-list',
    PUDO_TRANSACTION_VOLUME_BY_RECEIVER_LIST = 'pudo-transaction-volume-by-receiver-list',
    PUDO_TRANSACTION_TIMERS_DURATION_BY_USER_DROP_OFF_LIST = 'pudo-transaction-timers-duration-by-user-drop-off-list',
    PUDO_TRANSACTION_TIMERS_DURATION_BY_USER_PICK_UP_LIST = 'pudo-transaction-timers-duration-by-user-pick-up-list',
    NIVALIZ_TRANSACTION_VOLUME_LINE = 'nivaliz-transaction-volume-line',
    NIVALIZ_OUTBOUND_TRANSACTION_VOLUME_BY_STATE_LIST = 'nivaliz-outbound-transaction-volume-by-state-list',
    NIVALIZ_OUTBOUND_TRANSACTION_TIMER_PICK_UP_PENDING_WAITING_DAYS_STACKED_BAR = 'nivaliz-outbound-transaction-timer-pick-up-pending-waiting-days-stacked-bar',
    NIVALIZ_OUTBOUND_TRANSACTION_TIMER_DROP_OFF_PENDING_WAITING_DAYS_STACKED_BAR = 'nivaliz-outbound-transaction-timer-drop-off-pending-waiting-days-stacked-bar',
    NIVALIZ_INBOUND_TRANSACTION_TIMER_PICK_UP_PENDING_WAITING_DAYS_STACKED_BAR = 'nivaliz-inbound-transaction-timer-pick-up-pending-waiting-days-stacked-bar',
    NIVALIZ_INBOUND_TRANSACTION_TIMER_DROP_OFF_PENDING_WAITING_DAYS_STACKED_BAR = 'nivaliz-inbound-transaction-timer-drop-off-pending-waiting-days-stacked-bar',
    NIVALIZ_TRANSACTION_TIMER_ACTIVITY_WEEKDAY_HEATMAP = 'nivaliz-transaction-timer-activity-weekday-heatmap',
    NIVALIZ_OUTBOUND_TRANSACTION_TIMER_ACTIVITY_WEEKDAY_HEATMAP = 'nivaliz-outbound-transaction-timer-activity-weekday-heatmap',
    NIVALIZ_INBOUND_TRANSACTION_TIMER_ACTIVITY_WEEKDAY_HEATMAP = 'nivaliz-inbound-transaction-timer-activity-weekday-heatmap',
    NIVALIZ_TRANSACTION_TIMER_ACTIVITY_HOUR_DAY_HEATMAP = 'nivaliz-transaction-timer-activity-hour-day-heatmap',
    NIVALIZ_OUTBOUND_TRANSACTION_TIMER_ACTIVITY_HOUR_DAY_HEATMAP = 'nivaliz-outbound-transaction-timer-activity-hour-day-heatmap',
    NIVALIZ_INBOUND_TRANSACTION_TIMER_ACTIVITY_HOUR_DAY_HEATMAP = 'nivaliz-inbound-transaction-timer-activity-hour-day-heatmap',
    NIVALIZ_TRANSACTION_VOLUME_BY_SLOT_DIMENSION_DONUT = 'nivaliz-transaction-volume-by-slot-dimension-donut',
    TRANSACTION_TIMER_ACTIVE_VOLUME_BAR = 'transaction-timer-active-volume-bar',
    TRANSACTION_TIMER_PICK_UP_PENDING_COMPLETED_VOLUME_BAR = 'transaction-timer-pick-up-pending-completed-volume-bar',
    TRANSACTION_TIMER_DROP_OFF_PENDING_COMPLETED_VOLUME_BAR = 'transaction-timer-drop-off-pending-completed-volume-bar',
    TRANSACTION_TIMER_DROP_OFF_PENDING_DURATION_METRIC = 'transaction-timer-drop-off-pending-duration-metric',
    TRANSACTION_TIMER_PICK_UP_PENDING_DURATION_METRIC = 'transaction-timer-pick-up-pending-duration-metric',
    TRANSACTION_VOLUME_BY_CUSTOMER_BAR = 'transaction-volume-by-customer-bar',
    SPOT_FILL_RATE_LINE = 'spot-fill-rate-line',
    SPOT_FILL_RATE_METRIC = 'spot-fill-rate-metric',
    EQUIPMENT_STATE_ALL_LIST = 'equipment-state-all-list',
    EQUIPMENT_STATE_ALL_DONUT = 'equipment-state-all-donut',
    EQUIPMENT_TIMERS_DURATION_BY_PRODUCT_LIST = 'equipment-timers-duration-by-product-list',
    EQUIPMENT_TIMERS_DURATION_BY_EQUIPMENT_LIST = 'equipment-timers-duration-by-equipment-list',
    LENDING_EQUIPMENT_USES_VOLUME_BY_PRODUCT_LIST = 'lending-equipment-uses-volume-by-product-list',
    EQUIPMENT_CERTIFICATIONS_DONUT = 'equipment-certifications-donut',
    VENDING_PACKAGE_VOLUME_LINE = 'vending-package-volume-line',
    VENDING_PACKAGE_VOLUME_HOUR_BAR = 'vending-package-volume-hour-bar',
    LENDING_OUTBOUND_PACKAGE_VOLUME_HOUR_DAY_HEATMAP = 'lending-outbound-package-volume-hour-day-heatmap',
    LENDING_RETURN_PACKAGE_VOLUME_HOUR_DAY_HEATMAP = 'lending-return-package-volume-hour-day-heatmap',
    VENDING_TRANSACTION_VOLUME_BY_STATE_LIST = 'vending-transaction-volume-by-state-list',
    STOCK_VOLUME_BY_SPOT_LINE = 'stock-volume-by-spot-line',
    STOCK_VOLUME_BY_PRODUCT_LIST = 'stock-volume-by-product-list',
    STOCK_VOLUME_BY_PRODUCT_MONTHLY_LIST = 'stock-volume-by-product-monthly-list',
    FILL_RATE_BY_PRODUCT_LIST = 'fill-rate-by-product-list',
    FILL_RATE_BY_PRODUCT_LINE = 'fill-rate-by-product-line',
    FILL_RATE_BY_SPOT_LIST = 'fill-rate-by-spot-list',
    FILL_RATE_TOTAL_METRIC = 'fill-rate-total-metric',
    FILL_RATE_BY_PRODUCT_MONTHLY_LIST = 'fill-rate-by-product-monthly-list',
    CONSUMPTION_RATE_BY_PRODUCT_LIST = 'consumption-rate-by-product-list',
    VENDING_PACKAGE_VOLUME_BY_PRODUCT_LIST = 'vending-package-volume-by-product-list',
    VENDING_PACKAGE_VOLUME_BY_PRODUCT_MONTHLY_LIST = 'vending-package-volume-by-product-monthly-list',
    VENDING_PACKAGE_VOLUME_BY_USER_LIST = 'vending-package-volume-by-user-list',
    VENDING_PACKAGE_VOLUME_WEEKDAY_HEATMAP = 'vending-package-volume-weekday-heatmap',
    VENDING_PACKAGE_VOLUME_HOUR_DAY_HEATMAP = 'vending-package-volume-hour-day-heatmap',
    VENDING_PACKAGE_TIMERS_DURATION_AUDIT_PENDING_BY_PRODUCT_LIST = 'vending-package-timers-duration-audit-pending-by-product-list',
    VENDING_REPLENISHMENT_TRANSACTION_VOLUME_HOUR_DAY_HEATMAP = 'vending-replenishment-transaction-volume-hour-day-heatmap',
    VENDING_RECYCLE_SPOT_FILL_RATE_LINE = 'vending-recycle-spot-fill-rate-line',
    LENDING_OUTBOUND_PACKAGE_VOLUME_WEEKDAY_HEATMAP = 'lending-outbound-package-volume-weekday-heatmap',
    LENDING_RETURN_PACKAGE_VOLUME_WEEKDAY_HEATMAP = 'lending-return-package-volume-weekday-heatmap',
    LENDING_OUTBOUND_PACKAGE_VOLUME_BY_PRODUCT_LIST = 'lending-outbound-package-volume-by-product-list',
    LENDING_OUTBOUND_PACKAGE_VOLUME_BY_PRODUCT_MONTHLY_LIST = 'lending-outbound-package-volume-by-product-monthly-list',
    IOTS_VOLUME_BY_STATUS_DONUT = 'iots-volume-by-status-donut',
    IOTS_VOLUME_BY_TYPE_LIST = 'iots-volume-by-type-list',
    IOTS_VOLUME_BY_STATUS_BAR = 'iots-volume-by-status-bar',
    IOTS_UPTIME_LINE = 'iots-uptime-line',
    IOTS_UPTIME_METRIC = 'iots-uptime-metric',
    IOTS_UPTIME_BY_TYPE_LIST = 'iots-uptime-by-type-list',
    IOTS_UPTIME_WEEKDAY_HEATMAP = 'iots-uptime-weekday-heatmap'
}

export interface ChartFilter {
    key: string;
    value: string | number | boolean | string[];
}

export interface ChartDefinition {
    key: ChartKey | string;
    chartType: ChartRendererType;
    endpoint: string;
    filters: ChartFilter[];
    groupBy?: string;
    groupByMode?: ChartGroupByMode;
}
